import PropTypes from 'prop-types';
import React from 'react';
import {
  observationButton as btnCls,
  observationButtonActive as activeBtnCls,
  observationButtonInactive as inactiveBtnCls,
} from './ObservationButton.scss';

export default function ObservationButton(props) {
  const {
    onClick,
    name,
    existing,
    observation_type_code,
    className = '',
  } = props;

  return (
    <button
      className={`${btnCls} ${existing === true ? activeBtnCls : inactiveBtnCls} ${className}`}
      onClick={() => onClick(observation_type_code)}
      type="button"
      data-code={observation_type_code}
    >
      {name}
    </button>
  );
}

ObservationButton.propTypes = {
  onClick: PropTypes.func,
  existing: PropTypes.bool,
  observation_type_code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Common/ObservationButton.js